export enum UnifiedCardProductEnum {
    TAQMAN_GE = 'TAQMAN_GE',
    ARRAY_GX = 'ARRAY_GX',
    GT = 'GT',
    MICROBE_DETECTION = 'MICROBE_DETECTION',
    ANTIBIOTIC_RESISTANCE = 'ANTIBIOTIC_RESISTANCE',
    CNV = 'CNV',
    ADVANCED_MIRNA = 'ADVANCED_MIRNA',
    // ASSAYS_MIRNA = 'ASSAYS_MIRNA', // Old impl. Wrong product
    MIRNA_CONTROL_ASSAY = 'MIRNA_CONTROL_ASSAY', // Correct onig mira // Mirna Classic
    PRI_MIRNA = 'PRI_MIRNA',
    ARRAY_MIRNA = 'ARRAY_MIRNA',
}
